import { createRequestSaga } from "../base/request";
import { ApiResponse, verfiyResponse } from "../base/types/saga";
import { LanguageModel } from "./types";
import { call, put, takeLatest } from "@redux-saga/core/effects";
import languge from ".";

function* getLanguagesSaga() {
  try {
    const response: ApiResponse<LanguageModel[]> = yield call(
      createRequestSaga,
      {
        method: "GET",
        url: "System/Languages",
      }
    );
    if (verfiyResponse(response)) {
      yield put(languge.actions.setLanguages(response.Result));
    } else {
    }
  } catch (e) {
    console.log("ERROR currenciesSaga", e);
  }
}

const languageSaga = [
  takeLatest(languge.actions.getLanguages.toString(), getLanguagesSaga),
];
export default languageSaga;
